import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/goodreads-g': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M42.6 403.3H45.4C58.1 403.3 70.9 403.3 83.6 403.4 85.2 403.4 86.7 403 87.2 405.5 94.3 440.4 117.2 460.1 150.1 469.4 177 477 204.2 477.2 231.4 471.2 265.2 463.8 287.4 442.9 299.4 410.8 307.4 389.3 310.1 367 310.4 344.3 310.5 338.5 310.7 297.3 310.2 291.5L309.3 291.2C308.5 292.7 307.6 294.1 306.8 295.6 284.7 338.7 245.5 363 201.4 364.7 98.4 368.7 32 307.7 29.4 188.5 28.9 164.8 31.2 141.6 37.7 118.8 58.3 47.7 112.3 0.6 191.6 0 252.9-0.4 293.1 38.7 307.8 70.3 308.3 71.4 309.1 72.6 310.2 72.2V10.6H354.5C354.5 290.9 354.6 342.8 354.6 342.8 354.5 421.3 327.9 486.5 251.6 505 182.1 521.9 92.6 509.8 55.6 447.8 47.6 434.3 43.8 419.5 42.6 403.3zM188.9 36.5C136.4 36 80.4 77.2 73.9 170.3 69.8 229.3 88.7 292.5 145.4 318.9 173 331.8 219.7 333.9 253.7 310.2 301.3 277 316.4 213.2 308.5 156.2 298.8 85.1 260.7 36.2 188.9 36.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/goodreads-g.js
// module id = YB8m
// module chunks = 144